import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely extract a human-readable error message from any axios error / API payload.
 * The backend sometimes returns `detail` as an object (e.g. {message, violations}),
 * which crashes React if passed directly to a JSX child or toast. Always returns a string.
 */
export function extractErrorMessage(error, fallback = "Something went wrong") {
  if (!error) return fallback;

  // Axios error shape
  const data = error?.response?.data;
  let detail = data?.detail ?? data?.message ?? data;

  // Pydantic 422 validation errors: detail is an array of { loc, msg, type }
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first && typeof first === "object") return first.msg || first.message || fallback;
    if (typeof first === "string") return first;
    return fallback;
  }

  // Structured detail object from FastAPI HTTPException(detail={...})
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.detail === "string") return detail.detail;
    if (typeof detail.error === "string") return detail.error;
    try {
      return JSON.stringify(detail);
    } catch {
      return fallback;
    }
  }

  if (typeof detail === "string" && detail.trim()) return detail;
  if (typeof error.message === "string" && error.message.trim()) return error.message;
  return fallback;
}
